import '@hotwired/turbo-rails'

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// Preserve scroll position when navigating Back to a category view.
//
// Clicking a sidebar category navigates the #explorer <turbo-frame> with
// data-turbo-action="advance", which pushes a new history entry.
//
// Turbo records a scroll position per history entry, but only when a real
// `scroll` event fires. The swap replaces content in place without moving the
// page, so no `scroll` event fires at the moment the new entry is created,
// leaving that entry with no recorded position — so Back jumps to the top.
//
// Dispatching a `scroll` event once the new entry is the
// current one makes Turbo's ScrollObserver record where the user actually is,
// so Turbo's native Back/Forward restoration returns them there.
//
// Chain of events:
// - Turbo stores a scroll position per history entry, and only writes one when a real scroll event fires.
// - When you scroll the list, events fire and get recorded against the current entry (e.g. /).
// - Clicking a category does an advance frame swap, which pushes a brand-new history entry (/?category=…). The swap replaces content in place — the page doesn't move — so no scroll event fires at that instant, and
// the new entry is created with an empty scroll position.
// - If you then open a card and hit Back, Turbo restores that new entry, finds no stored position, and jumps to top.
document.addEventListener('turbo:frame-load', (event) => {
  if (event.target.id === 'explorer') {
    dispatchEvent(new Event('scroll'))
  }
})
